<template>
  <mf-card-container
    title="Produtos correlatos"
    description="Produtos que não estão na campanha mas estiveram mais presentes nos cupons dos clientes que receberam a campanha."
  >
    <template #headers>
      <export-data v-if="relatedProducts.length" :data-fetcher="getDataToExport" filename="produtos_correlatos" ghost />
    </template>
    <mf-loading :boolean-loader="loading" loader-type="table">
      <v-data-table
        v-if="relatedProducts.length"
        :items="relatedProducts"
        :headers="headers"
        :items-per-page="5"
        :footer-props="{
          'items-per-page-options': [5],
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-center">{{ item.index }}°</td>
            <td>
              {{ item.product }}
            </td>
            <td>{{ item.coupons }}</td>
            <td>{{ item.distribution }}%</td>
          </tr>
        </template>
      </v-data-table>
      <empty-chart v-else />
    </mf-loading>
  </mf-card-container>
</template>

<script>
import EmptyChart from '@/modules/mobile/desempenho/views/components/EmptyChart'
import ExportData from '@/components/export-data/ExportData.vue'

export default {
  name: 'RelatedProducts',
  components: {
    EmptyChart,
    ExportData,
  },
  props: {
    dataChart: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    exporting: false,
  }),
  computed: {
    headers() {
      return [
        {
          value: 'index',
          width: '8%',
        },
        {
          text: 'Produto',
          value: 'product',
          width: '50%',
        },
        {
          text: 'Cupons',
          align: 'left',
          value: 'coupons',
          width: '17%',
        },
        {
          text: 'Distribuição',
          align: 'left',
          value: 'distribution',
          width: '24%',
        },
      ]
    },
    relatedProducts() {
      if (!this.dataChart?.related_table && !this.dataChart?.related_table.length) return []
      const totalTickets = this.dataChart.totals.received.tickets
      return this.dataChart?.related_table
        .map((relatedProduct) => {
          return {
            product: relatedProduct?.product?.name,
            coupons: relatedProduct?.tickets,
            distribution: Math.round((relatedProduct?.tickets / totalTickets) * 100),
          }
        })
        .sort((a, b) => a.distribution - b.distribution)
        .reverse()
        .map((relatedProduct, index) => {
          return {
            index: index + 1,
            ...relatedProduct,
          }
        })
    },
  },
  methods: {
    async getDataToExport() {
      this.exporting = true
      try {
        const rows = this.relatedProducts.map((obj) => {
          return [obj.index, obj.product, obj.coupons, obj.distribution]
        })
        const headers = ['Posição', 'Produto', 'Cupons', 'Distribuição']
        this.exporting = false
        return { headers, rows }
      } catch {
        this.$snackbar({ message: 'Falha na exportação de produtos correlatos' })
      }
    },
  },
}
</script>

<style lang="scss">
.export-csv {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $marca-0-l40 !important;
  text-transform: none;
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
}
</style>
